import { put, takeLatest } from "redux-saga/effects";

import {
  deleteCustomDomainMappingFailure,
  deleteCustomDomainMappingRequest,
  deleteCustomDomainMappingSuccess,
  getCustomDomainMappingFailure,
  getCustomDomainMappingRequest,
  getCustomDomainMappingSuccess,
  updateCustomDomainMappingFailure,
  updateCustomDomainMappingRequest,
  updateCustomDomainMappingSuccess
} from "../features/customDomainTemplateMapping";
import { httpDelete, httpGet, httpPut } from "../../services";

function* fetchCustomDomainMapping() {
  try {
    const response = yield httpGet("/deployment/customdomain/bindingrequest", {});
    if (response.ErrorCode) {
      if (response.ErrorCode === 8214) {
        throw new Error("");
      } else {
        throw new Error(response.Description || response.Message || response.ErrorMessage);
      }
    }
    yield put(getCustomDomainMappingSuccess(response));
  } catch (error: any) {
    yield put(getCustomDomainMappingFailure(error.message));
  }
}

function* updateCustomDomainMapping(action: ReturnType<typeof updateCustomDomainMappingRequest>) {
  try {
    const data = action.payload;
    const response = yield httpPut(`/deployment/custom-domain-mapping`, {}, data);
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(updateCustomDomainMappingSuccess(response));
  } catch (error: any) {
    yield put(updateCustomDomainMappingFailure(error.message));
  }
}

function* deleteCustomDomainMapping(action: ReturnType<typeof deleteCustomDomainMappingRequest>) {
  try {
    const customDomain = action.payload;
    const response = yield httpDelete(`/deployment/custom-domain-mapping/${customDomain}`, {});
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message || response.ErrorMessage);
    }
    yield put(deleteCustomDomainMappingSuccess(customDomain));
  } catch (error: any) {
    yield put(deleteCustomDomainMappingFailure(error.message));
  }
}

export default function* watchCustomDomainMappingSaga() {
  yield takeLatest(getCustomDomainMappingRequest.type, fetchCustomDomainMapping);
  yield takeLatest(updateCustomDomainMappingRequest.type, updateCustomDomainMapping);
  yield takeLatest(deleteCustomDomainMappingRequest.type, deleteCustomDomainMapping);
}
